import React, { useContext } from 'react';
import { Form, Typography, Space, Button, Descriptions } from 'antd';
import { getTranslatedString } from 'helpers/i18n';
import { ApplicationUIContext } from '@yuhuinc/ui-library';
import { SpaceFullWidth } from '../../common/Styles';

const { Title } = Typography;

const translate = (key) =>
  getTranslatedString(`landlordPortal.applicationManagement.leaseOverview.${key}`);

const PropertyAndUnit = ({ disabled }) => {
  const { isMobile } = useContext(ApplicationUIContext);
  const form = Form.useFormInstance();

  return (
    <>
      <Title level={isMobile ? 4 : 5}>{translate('leaseDetails.propertyAndUnit')}</Title>

      <SpaceFullWidth direction="vertical" size="middle">
        <Form.Item shouldUpdate>
          {() => (
            <Descriptions bordered size="small" column={1}>
              <Descriptions.Item label={translate('leaseDetails.propertyAndUnit.building')}>
                {form.getFieldValue(['selectedUnit', 'property_name'])}
              </Descriptions.Item>
              <Descriptions.Item label={translate('leaseDetails.propertyAndUnit.unit')}>
                {form.getFieldValue(['selectedUnit', 'unit_number'])}
              </Descriptions.Item>
            </Descriptions>
          )}
        </Form.Item>

        <Space size="middle">
          <Button htmlType="button" disabled={disabled}>
            {translate('leaseDetails.propertyAndUnit.editUnit')}
          </Button>
          <Button htmlType="button" disabled={disabled}>
            {translate('leaseDetails.propertyAndUnit.transferLease')}
          </Button>
        </Space>
      </SpaceFullWidth>
    </>
  );
};

export default PropertyAndUnit;
